import { TwilioIntegration_Read, TwilioRegion } from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

const twilioRegionIsOffered = {
  [TwilioRegion.CA]: true,
  [TwilioRegion.US]: true,
} satisfies Record<TwilioRegion, boolean>;

export const TWILIO_REGIONS = Object.values(TwilioRegion).filter(
  (twilioRegion) => twilioRegionIsOffered[twilioRegion],
);

export class TwilioIntegration {
  public static parse(proto: TwilioIntegration_Read): TwilioIntegration {
    return new TwilioIntegration(
      proto.id,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.phone,
      proto.twilio_region,
    );
  }

  public get id(): string {
    return this._id;
  }

  public get createdAt(): Dayjs {
    return this._createdAt;
  }

  public get updatedAt(): Dayjs {
    return this._updatedAt;
  }

  public get phone(): string {
    return this._phone;
  }

  public get twilioRegion(): TwilioRegion {
    return this._twilioRegion;
  }

  constructor(
    private _id: string,
    private _createdAt: Dayjs,
    private _updatedAt: Dayjs,
    private _phone: string,
    private _twilioRegion: TwilioRegion,
  ) {}
}
